module.exports = __webpack_public_path__ + "img/4d5ae5ea4f7389dee7d506a52dd99103.4ba76789.png";